<template>
  <div>
    <div v-if="orderedModules.length > 0" class="milestones-cards-container" :class="setModulesLayout ? 'grid-view': 'list-view'">
    <k-panel-card
      v-for="mod in orderedModules"
      :key="mod.name"
      :item="mod">
    </k-panel-card>
  </div>
  <empty-placeholder v-else
    title="No modules available in this section"
    :info="emptyTrackText"
    :fa-icon="emptyIcon"
    ></empty-placeholder>
  </div>

</template>

<script>
import EmptyPlaceholder from '@base-components/empty-placeholder.vue';
import KPanelCard from './components/k-panel-card.vue';

export default {
  components: {
    KPanelCard,
    EmptyPlaceholder,
  },
  props: {
    programmeId: {
      type: Number,
      required: true,
    },
    orderedModules: {
      type: Array,
      required: true,
    },
    setModulesLayout: Boolean,
  },

  computed: {
    programmeScheduleLink() {
      return `<a href="/programmes/${this.programmeId}/schedule">Schedule Page</a>`;
    },

    emptyTrackText() {
      return `You can check the ${this.programmeScheduleLink} to see when each module will be released in this programme.
      <br>To see modules in other tracks, select a different track from the tabs above`;
    },

    emptyIcon() {
      return 'fa-duotone fa-hourglass-start';
    },
  },
};
</script>
